import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import PageContainer from './containers/PageContainer';

import { rootNode, initParams, storeConfiguration } from './config';
import { configureStore, initData } from '../../store';

const stateStore = configureStore(storeConfiguration);

const { assetsData } = initParams;

class AboutPage extends Component {
  constructor(props) {
    super(props);
    stateStore.dispatch(initData(assetsData));
  }
  render() {
    return (
      <Provider store={stateStore}>
        <PageContainer />
      </Provider>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<AboutPage />);
});
